import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { UsersOfOrg } from '../common/components/UsersOfOrg';

export class UsersOfOrgCustomRead extends UsersOfOrg {


  constructor(props) {
    super(props)
    this.noAdd = true
    this.pageTitle = 'Users of Organisation'
    this.tableHeadersMap = {
      Index: (current) => { return current.__index + 1 },
      Email: (current) => { return current.email },
      Name: (current) => { return Helper.formatName(current) },
    }
  }

  onFetchSuccess(results) {
    super.onFetchSuccess(results)
    this.formDefinition.steps[0].fields = this.formDefinition.steps[0].fields.filter(f => {
      return Helper.inArray(['email', 'givenname', 'familyname'], f.key)
    })
  }

  onActions(current) {
    const actions = []
    return actions
  }
}


// WEBPACK FOOTER //
// ./src/components/UsersOfOrgCustomRead.js